/**
 * A map of key names as used by the `event.key` property
 * in `keyDown`/`keyUp` event handlers.
 *
 * (Unfortunately TypeScript doesn't check the validity of
 * key strings, so using this object can help prevent typos.)
 */

export var KEY = {
  TAB: 'Tab',
  SPACE: ' ',
  ENTER: 'Enter',
  BACKSPACE: 'Backspace',
  DELETE: 'Delete',
  ESC: 'Escape',
  SHIFT: 'Shift',
  CONTROL: 'Control',
  META: 'Meta',
  PAGE_UP: 'PageUp',
  PAGE_DOWN: 'PageDown',
  HOME: 'Home',
  END: 'End',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown'
};